import { SliderWithArrowsScroll } from "../../../global/sliders/material/SliderWithArrowsScroll";
import { ClickableChip } from "../../../global/chips/ClickableChip";
import { Check } from "@mui/icons-material";
import { setIdFilters } from "../../../../redux/filtersSlice";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../../redux/store";
import { MOCK_ARRAY_10 } from "../../../../lib/constants";
import { DefaultLoadingComponent } from "../../../global/defaultLoading/DefaultLoadingComponent";

export const BlogFiltersSlider = () => {
  const exploreFilters = useSelector(
    (state: RootState) => state.explore.value.filtersList,
  );
  const filters = useSelector((state: RootState) => state.filters);
  const dispatch = useDispatch();

  if (exploreFilters.objectives.length === 0) {
    return (
      <SliderWithArrowsScroll>
        {MOCK_ARRAY_10.map((item) => (
          <DefaultLoadingComponent width={160} height={38} key={item} />
        ))}
      </SliderWithArrowsScroll>
    );
  }

  return (
    <SliderWithArrowsScroll>
      {exploreFilters?.objectives?.map((item) => (
        <ClickableChip
          key={item.id}
          label={item.title}
          isSelected={filters["blogs"].objectives.includes(item.id)}
          icon={
            filters["blogs"].objectives.includes(item.id) ? <Check /> : null
          }
          onClick={() => {
            dispatch(
              setIdFilters({
                id: item.id,
                type: "objectives",
                filterFor: "blogs",
              }),
            );
          }}
        />
      ))}
    </SliderWithArrowsScroll>
  );
};
